import React, { useEffect } from "react";
import { connect } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/scss/main.scss";
import "../assets/scss/structure.scss";
import "simplebar-react/dist/simplebar.min.css";
import Navbar from "./Navbar";
import SidebarMenu from "./SidebarMenu";
import CSRFToken from "../components/CSRFToken";
import { checkAuthenticated } from "../actions/accounts/auth";
import { useIsAuthenticated } from "../reducers/accounts/auth";
import { getSelfUser } from "../actions/accounts/user";

const Layout = ({ children, checkAuthenticated, getSelfUser }) => {
  // const pageMeta = usePageMeta();
  // useEffect(() => {
  //     Application.init();
  // }, [pageMeta?.title]);
  const { isAuthenticated } = useIsAuthenticated();
  useEffect(() => {
    checkAuthenticated();
  }, [checkAuthenticated]);
  useEffect(() => {
    if (isAuthenticated) {
      getSelfUser();
    }
  }, [isAuthenticated, getSelfUser]);
  return (
    <>
      <CSRFToken />
      {isAuthenticated && (
        <>
          <Navbar />
          <div className="main-container" id="container">
            <div className="overlay no-print"></div>
            <div className="search-overlay no-print"></div>

            <SidebarMenu />

            <div id="content" className="main-content">
              <div className="layout-px-spacing">{children}</div>
              <div className="footer-wrapper no-print">
                <div className="footer-section f-section-1">
                  <p className="">
                    Copyright © 2021-{new Date().getFullYear()}{" "}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.apogeemattress.com"
                    >
                      Apogee Mattress
                    </a>
                    , All rights reserved.
                  </p>
                </div>
                <div className="footer-section f-section-2">
                  <p className="">
                    Developed by{" "}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.ampliquity.com"
                    >
                      Ampliquity Technologies
                    </a>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default connect(null, { checkAuthenticated, getSelfUser })(Layout);
